// Components
import Modal from 'components/General/Modal/Modal';
import { AssignmentCard } from 'components/Dashboard/AssignmentCard/AssignmentCard';
import { CourseLayout } from 'layouts/CourseLayout/CourseLayout';
import { AssignmentEvent } from 'components/Dashboard/AssignmentEvent/AssignmentEvent';
import { NewAssignment } from './NewAssignment/NewAssignment';
import { ReuseAssignment } from './ReuseAssignment/ReuseAssignment';

// Style
import './Assignment.scss';

// Logic
import { useLogic } from './Assignment.logic';

// uuid
import { v4 as uuid } from 'uuid';
import DotsLoader from 'components/General/Loader/Loader';
import { GiveMark } from './GiveMark/GiveMark';

// images
import SideBarImage from 'assets/images/student-side.svg';
import { setToggleNewAssignmentModal, setToggleReuseAssignmentModal } from 'pages/Dashboard/Course/Assignment/AssignmentSlice';
import { UpcomingEvent } from 'components/Dashboard/UpcomingEvent/UpcomingEvent';
import { setAssignment } from 'pages/Dashboard/DashboardSlice';
import LineChart from 'components/AdminDashboard/LineChart/LineChart';
import moment from 'moment-timezone';

export const Assignment = () => {
  const {
    isLoading,
    assignmentsData,
    handeRemove,
    dispatch,
    setMark,
    dashboardState,
    assignmentState,
    userNearestAssignment,
    adminNearestAssignment,
    isLoadingnAdminNearestAssignment,
    isLoadingnUserNearestAssignment,
    handleEdit,
    isAdmin,
    isTeacher,
    chartData,
    isLoadingChartData
  } = useLogic();

  return (

    <>
      <CourseLayout sidebarContent={(
        <div className="sidebar">
          <div className="sidebar-events-container">
            {(isAdmin || isTeacher) ? (
              <>
                <div className="sidebar-event-container">
                  <AssignmentEvent
                    title="Create new assignment"
                    buttonText="Create"
                    onClick={() => dispatch(setToggleNewAssignmentModal())}
                  />
                </div>
                <div className="sidebar-event-container">
                  <AssignmentEvent
                    title="Reuse assignment"
                    buttonText="Reuse"
                    onClick={() => dispatch(setToggleReuseAssignmentModal())}
                  />
                </div>
                <div className="sidebar-event-container">
                  {(adminNearestAssignment?.adminNearestAss && adminNearestAssignment?.adminNearestAss.length > 0) ? (
                    <>
                      <h2 className="ml-1">Last assignment</h2>
                      <UpcomingEvent
                        title={adminNearestAssignment.adminNearestAss?.[0]?.name}
                        date={adminNearestAssignment?.adminNearestAss?.[0]?.dueDate}
                        onClick={() => dispatch(setAssignment({ assignment: adminNearestAssignment?.adminNearestAss?.[0], tab: 'Assignments' }))}
                      />
                    </>
                  ) : (
                    <>
                      {(isLoadingnAdminNearestAssignment || isLoadingChartData) && (
                      <DotsLoader />
                      )}

                    </>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="sidebar-event-container">
                  <img
                    src={SideBarImage}
                    alt=""
                  />
                </div>
                <div className="sidebar-event-container">
                  {(userNearestAssignment?.userNearestAss && userNearestAssignment?.userNearestAss.length > 0) ? (
                    <>
                      <h2 className="ml-1">Last Assignment</h2>
                      <UpcomingEvent
                        title={userNearestAssignment?.userNearestAss?.[0]?.name}
                        date={userNearestAssignment?.userNearestAss?.[0]?.dueDate}
                        onClick={() => dispatch(setAssignment({ assignment: userNearestAssignment.userNearestAss?.[0], tab: 'Assignments' }))}
                      />
                    </>
                  ) : (
                    <>
                      {isLoadingnUserNearestAssignment && (
                      <DotsLoader />
                      )}
                    </>
                  )}

                </div>
              </>
            )}
          </div>
          <div className="chart mt-2">
            <h2>Grades chart</h2>
            <LineChart
              maxStep={10}
              data={{
                labels: chartData?.userAssignmentsChart?.names.map((date) => moment(date).format('YYYY-MM-DD')) || [],
                datasets: [{
                  label: 'Grade %',
                  data: chartData?.userAssignmentsChart?.marks || [],
                  backgroundColor: '#6371E0',
                  borderColor: '#6371E0',
                  pointRadius: 10,
                  pointBackgroundColor: '#6371E0',
                  pointHoverBackgroundColor: '#6371E0',
                  pointHoverRadius: 11,
                  type: 'line',
                }]
              }}
            />
          </div>
        </div>
      )}
      >
        <div className="class-body-container">
          <h2>{dashboardState.assignment.assignment?.classId ? 'Last assignment' : 'Last assignments'}</h2>
          {isLoading ? (
            <DotsLoader />
          ) : (
            <div className="assignments-container">
              {dashboardState.assignment.assignment?.classId ? (
                <AssignmentCard
                  key={uuid()}
                  classId={dashboardState.assignment.assignment?.classId}
                  id={dashboardState.assignment.assignment?.id}
                  title={dashboardState.assignment.assignment?.name}
                  date={dashboardState.assignment.assignment?.dueDate}
                  status={dashboardState.assignment.assignment?.status}
                  fullMark={dashboardState.assignment.assignment?.fullMark}
                  receivedMark={dashboardState.assignment.assignment?.receivedMark}
                  body={dashboardState.assignment.assignment?.details}
                  attachments={dashboardState.assignment.assignment?.attachments}
                  ungraded={dashboardState.assignment.assignment?.ungraded}
                  onEdit={() => handleEdit(dashboardState.assignment)}
                  onRemove={() => handeRemove(dashboardState.assignment.assignment?.id)}
                  toggleModal={() => {
                    dispatch(setMark({ originalMark: dashboardState.assignment.assignment?.fullMark, id: dashboardState.assignment.assignment?.id, toggleModal: true }));
                  }}
                />
              ) : (
                assignmentsData?.userClassAss?.map((assignment) => (
                  <AssignmentCard
                    key={uuid()}
                    classId={assignment.classId}
                    id={assignment.id}
                    title={assignment.name}
                    date={assignment.dueDate}
                    status={assignment.status}
                    fullMark={assignment.fullMark}
                    receivedMark={assignment.receivedMark}
                    body={assignment.details}
                    attachments={assignment.attachments}
                    ungraded={assignment.ungraded}
                    onEdit={() => handleEdit(assignment)}
                    onRemove={() => handeRemove(assignment.id)}
                    toggleModal={() => {
                      dispatch(setMark({ originalMark: assignment.fullMark, id: assignment.id, toggleModal: true }));
                    }}
                  />
                ))
              )}

            </div>
          )}
        </div>
      </CourseLayout>
      {(isAdmin || isTeacher) && (
        <>
          <Modal
            isClosble
            isOpen={assignmentState.showNewAssignmentModal}
            onRequestClose={() => dispatch(setToggleNewAssignmentModal())}
            fullHeight
          >
            <NewAssignment closeModal={() => dispatch(setToggleNewAssignmentModal())} />
          </Modal>

          <Modal
            isClosble
            isOpen={assignmentState.showReuseAssignmentModal}
            onRequestClose={() => dispatch(setToggleReuseAssignmentModal())}
            fullHeight
          >
            <ReuseAssignment onReuseClick={() => {
              dispatch(setToggleReuseAssignmentModal());
              dispatch(setToggleNewAssignmentModal());
            }}
            />
          </Modal>
          <Modal
            isClosble
            isOpen={assignmentState?.mark?.toggleModal}
            onRequestClose={() => dispatch(setMark({ toggleModal: false }))}
          >
            <GiveMark />
          </Modal>
        </>
      )}
    </>
  );
};
